import { IAction } from "../interfaces/action.interface";

export interface IPreferencesReducer {
    themeMode: "light" | "dark" | "default";
}

const initialState : IPreferencesReducer = {
    themeMode: "default",
};

const preferencesReducer = (state:IPreferencesReducer=initialState, action:IAction) : IPreferencesReducer => {
    switch(action.type) {
        default: {
            return state; 
        }
    }
};

export { preferencesReducer };